import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as ResizeObserver_es from '../node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js';

var require$$8 = /*@__PURE__*/getAugmentedNamespace(ResizeObserver_es);

export { require$$8 as default };
